"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BindingCount = {
  MultipleBindingsAvailable: 2,
  NoBindingsAvailable: 0,
  OnlyOneBindingAvailable: 1
};
exports.BindingCount = BindingCount;